import "./configuracion.scss"

import { SpinnerCircleMini } from "../../atoms/spinner/Spinner";
import { useEffect, useState } from "react";

import TituloCard from "../../atoms/titles/Titulo";
import { getEstadoAccesoCredenciales } from "../../services/LoginService";


const Configuracion = (object) => {

    const [loading, setLoading] = useState(false);
    const [estadoAccesoCred, setEstadoAccesoCred] = useState()

    useEffect(() => {
        getEstadoAccesoCredenciales().then((data) => {
            // true → hay acceso (permitido), false → no hay acceso
            

            setEstadoAccesoCred(data);
            setLoading(true) // invertimos porque en el original era "bloqueado"
        }).catch((err) => {
            // Por precaución, bloqueamos si hay error
            setEstadoAccesoCred(false);
        });
    }, []);
    return (
        <>
            <TituloCard tipo="tituloModal" titulo={<h2 className="tituloPagina4">Configuración</h2>} />
            
            <div className="row">
                
            </div>
      <h3 className="tituloPagina3">Acceso por Usuario/Contraseña</h3>
            

            {loading ? (
                <div className="fw-bold">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="checkbox" checked={estadoAccesoCred ? true :false} disabled/>
                        <label class="form-check-label" for="inlineCheckbox1">Activo</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="checkbox" id="inlineCheckbox2" checked={estadoAccesoCred ? false : true} disabled/>
                        <label class="form-check-label" for="inlineCheckbox2">Inactivo</label>
                    </div>
                </div>
            ) : (
                <SpinnerCircleMini></SpinnerCircleMini>
            )}

        </>
    );
};
export default Configuracion;